// WARNING: This file is loaded by both webpack (babel) and nodejs code and
//          should avoid babel-only features not yet supported by nodejs


export function encodeTextNode(str)
{
  return str.split('&').join('&amp;')
            .split('<').join('&lt;')
            .split('>').join('&gt;');
}

export function encodeValue(str)
{
  return str.split('&').join('&amp;')
            .split('<').join('&lt;')
            .split('>').join('&gt;')
            .split('"').join('&quot;')
            .split("'").join('&apos;');
}

export function decodeValue(str)
{
  return str.replace(/<br *\/?>/g, "\n")
            .replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec))
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&quot;/g, '"')
            .replace(/&apos;/g, "'")
            .replace(/&amp;/g, "&");
}



// WEBPACK FOOTER //
// /opt/wh/whtree/~/dompack/extra/encoding.es